'use client';

import type { Ref } from 'react';

import NumberFlow from '@number-flow/react';
import classnames from 'classnames';

import { Icon } from '../icon';
import type { IconCounterProps } from './IconCounter.types';

import styles from './IconCounter.module.scss';

const DEFAULT_NUMBER_FORMAT = {
  notation: 'compact' as const,
  maximumFractionDigits: 2,
};

export function IconCounter({
  style,
  className,
  icon,
  count,
  shadow = false,
  iconClassName,
  iconSize = 'sm',
  locales = ['es'],
  format,
  testId = 'ui-icon-counter',
  ref,
  ...rest
}: IconCounterProps & { ref?: Ref<HTMLDivElement> }) {
  const numberFormat = format || DEFAULT_NUMBER_FORMAT;

  return (
    <div
      ref={ref}
      style={style}
      className={classnames(styles['icon-counter'], className)}
      data-testid={testId}
      {...rest}
    >
      <Icon
        icon={icon}
        size={iconSize}
        className={classnames(
          shadow && styles['icon-counter__icon--shadow'],
          iconClassName,
        )}
      />
      <span className={styles['icon-counter__count']}>
        <NumberFlow value={count} format={numberFormat} locales={locales} />
      </span>
    </div>
  );
}
